import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledAccordionActionsItem, StyledToggleButton } from './style';
import Icon from '../Icon';
import { ArrowDown } from '../../../../assets/images/index';

/**
 * Componente AccordionActionsItem. (Cada uno de los items de AccordionActions)
 *
 * @param {React.Component} children - Debería recibir un componente AccordionActionsItemPrimary y un componente AccordionActionsItemSecondary.
 * @param {React.Props} onClick - Función que se dispara al hacer click sobre  AccordionActionsItem
 * @param {React.Props} expanded - Verdadero para que aparezca desplegado
 */
class AccordionActionsItem extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.state = {
      expanded: props.expanded ? props.expanded : false
    };
  }

  onClick() {
    const { expanded } = this.state;
    this.setState({ expanded: !expanded });
  }

  render() {
    const { className, children } = this.props;
    return (
      <StyledAccordionActionsItem
        onClick={this.onClick}
        expanded={this.state.expanded}
        className={className}
      >
        {children && (
          <StyledToggleButton
            transparent
            expanded={this.state.expanded}
            onClick={this.onClick}
          >
            <Icon svg={ArrowDown} />
          </StyledToggleButton>
        )}
        {children}
      </StyledAccordionActionsItem>
    );
  }
}

AccordionActionsItem.propTypes = {
  className: PropTypes.string,
  expanded: PropTypes.bool
};

AccordionActionsItem.defaultProps = {
  className: undefined,
  expanded: undefined
};

export default AccordionActionsItem;
